<button
  (click)="attemptSocialAuth()"
  type="button"
  class="btn m-b-10 btn-md btn-block"
  [ngClass]="{
    disabled: isSubmitting,
    'btn-facebook': provider === 'Facebook',
    'btn-twitter': provider === 'Twitter',
    'btn-danger': provider === 'Google'
  }"
>
  <i
    class="fa"
    [ngClass]="{
      'fa-facebook': provider === 'Facebook',
      'fa-twitter': provider === 'Twitter',
      'fa-google': provider === 'Google'
    }"
  ></i>
  <span *ngIf="useCase === 'sign-in'">Login with {{ provider }}</span>
  <span *ngIf="useCase === 'sign-up'">Sign up with {{ provider }}</span>
  <span *ngIf="useCase === 'link'">Link {{ provider }} account</span>

  <!-- Content marker -->
  <ng-content></ng-content>
</button>
